export const PaymentTypes = {
    current: 1,
    replacement: 2
}